export default __webpack_public_path__ + "static/media/CNo.70-0.2a34be01.jpg";